import React from "react";
import { SendRegular } from "@fluentui/react-icons";
import { Button, Field, Textarea, RadioGroup, Radio, ProgressBar } from "@fluentui/react-components";
import { formStyles, stackColumnGap12, stackColumnGap6, textareaClass } from "./styles";
import options from "./options";

type FeedbackFormProps = {
  comment: string;
  selectedFeedbackType: string | null;
  isPending: boolean;
  onFeedbackTypeChange: (value: "Like" | "Dislike" | "Idea") => void;
  onCommentChange: (comment: string) => void;
  onSubmit: () => void;
};

const FeedbackForm: React.FC<FeedbackFormProps> = ({
  comment,
  selectedFeedbackType,
  isPending,
  onFeedbackTypeChange,
  onCommentChange,
  onSubmit,
}) => {
  const selectedOption = options.find((o) => o.id === selectedFeedbackType) ?? null;

  const onRadioChange = (_: React.ChangeEvent<HTMLInputElement>, data: { value: string }) => {
    onFeedbackTypeChange(data.value as "Like" | "Dislike" | "Idea");
  };

  const onFeedbackChange = (ev: React.ChangeEvent<HTMLTextAreaElement>) => {
    onCommentChange(ev.target.value);
  };

  const onFormSubmit = (ev: React.FormEvent<HTMLFormElement>) => {
    ev.preventDefault();
    onSubmit();
  };

  return (
    <div>
      <div className={stackColumnGap12}>
        <RadioGroup value={selectedFeedbackType ?? ""} onChange={onRadioChange}>
          {options.map((opt) => (
            <Radio key={opt.id} value={opt.id} label={opt.text} />
          ))}
        </RadioGroup>
        {selectedFeedbackType && (
          <form onSubmit={onFormSubmit} className={formStyles}>
            <div className={stackColumnGap6}>
              <Field label={selectedOption?.key ?? ""}>
                <Textarea
                  value={comment}
                  onChange={onFeedbackChange}
                  rows={5}
                  resize="none"
                  className={textareaClass}
                />
              </Field>
              {isPending && <ProgressBar />}
              <Button appearance="primary" type="submit" disabled={!comment}>
                Send
                <SendRegular aria-label="Send" style={{ color: "white", fontSize: 12, marginLeft: 10 }} />
              </Button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default FeedbackForm;
